import type { Character } from '@/types/api.type';
import { SectionListItem } from './SectionListItem';

export const SectionList = ({
  moduleApi,
  label,
  data,
}: {
  moduleApi: string;
  label: string;
  data: Character[];
}) => {
  return (
    <section className="mb-12" key={moduleApi}>
      <h2 className="text-2xl font-bold mb-4">{label}</h2>
      <div className="bg-gray-800 text-gray-400 p-4 rounded mb-4 overflow-x-auto">
        <code>
          [GET]{' '}
          {`${process.env.NEXT_PUBLIC_API_SERVER_URL}${moduleApi}?limit=4`}
        </code>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {data && data.length > 0 ? (
          data.map((item) => (
            <SectionListItem
              key={item._id}
              title={item.name}
              slug={item.slug}
            />
          ))
        ) : (
          <p>No data available.</p>
        )}
      </div>
    </section>
  );
};
